import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 text-white relative overflow-hidden" data-id="element-31" data-mp="elo439pydn5o">
      {/* Subtle decorative accents */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-32" data-mp="ao0803cixoc7" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12" data-id="element-33" data-mp="oj51tonpojx">
        {/* Top CTA strip */}
        <div className="py-16 border-b border-white/10" data-id="element-34" data-mp="3s25c0bcfdhhh">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center" data-id="element-35" data-mp="3s0kf4f2n1mgg">
            <div className="lg:col-span-7" data-id="element-36" data-mp="3n43qljrj162u">
              <div className="flex items-center gap-3 mb-4" data-id="element-37" data-mp="3j28seo4w78ta">
                <div className="w-10 h-px bg-gold-500" data-id="element-38" data-mp="3j3tm6bjdunq3" />
                <span className="text-gold-500 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-39" data-mp="3e35ley5cqsio">
                  Begin a Conversation
                </span>
              </div>
              <h3 className="text-3xl md:text-4xl font-serif font-bold leading-tight" data-id="element-40" data-mp="2kdd1eqhs0vpm">
                Considering your next critical hire?
                <span className="block text-gold-500 italic mt-1" data-id="element-41" data-mp="2p4mnjh449gwr">
                  Let's talk.
                </span>
              </h3>
            </div>
            <div className="lg:col-span-5 lg:text-right" data-id="element-42" data-mp="2gb9nzwbjrh1p">
              <a href="mailto:contact@talentbridge.blog" className="inline-flex items-center gap-3 group" data-id="element-43" data-mp="2gbrgqiz03d4v">
                <span className="text-2xl md:text-3xl font-serif text-white group-hover:text-gold-500 transition-colors" data-id="element-44" data-mp="3837bj0apo666">
                  Request a consultation
                </span>
                <div className="w-12 h-12 rounded-full border border-white/30 flex items-center justify-center group-hover:bg-gold-500 group-hover:border-gold-500 transition-all" data-id="element-45" data-mp="2z1r2owzjoc42">
                  <ArrowUpRight className="h-5 w-5" data-id="element-46" data-mp="1iq3uus068d7l" />
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Main grid */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12" data-id="element-47" data-mp="13k7uq8sc8tmg">
          {/* Brand block */}
          <div className="lg:col-span-4" data-id="element-48" data-mp="zl8toz9q9h0a">
            <Link to="/" className="flex items-center gap-4 mb-6" data-id="element-49" data-mp="urw4amx8566h">
              <div className="w-14 h-14 rounded-full bg-white/10 border border-gold-500/40 flex items-center justify-center" data-id="element-50" data-mp="uq2wv5esehxf">
                <span className="text-gold-500 font-serif font-bold text-base" data-id="element-51" data-mp="kurgkinqd2nk">
                  TB
                </span>
              </div>
              <div data-id="element-52" data-mp="ftlomn1w9jf3">
                <div className="text-xl font-serif font-bold tracking-wide" data-id="element-53" data-mp="fx9ixof5y9uv">
                  TalentBridge
                </div>
                <div className="text-xs font-medium tracking-[0.2em] uppercase text-gold-500" data-id="element-54" data-mp="6uqjleal6fdd">
                  Global
                </div>
              </div>
            </Link>
            <p className="text-gray-400 leading-relaxed mb-5 text-sm" data-id="element-55" data-mp="2658av5kdc2wc">
              A global executive search and leadership advisory firm. We help
              boards, CEOs, and investors secure transformative leadership
              talent across 42 markets worldwide.
            </p>
            <Link to="/recruitment-safety" className="inline-flex items-center gap-2 text-xs text-gold-500 hover:text-white transition-colors mb-8" data-id="element-56" data-mp="2dp0x413o3zsk">
              <span className="w-2 h-2 rounded-full bg-gold-500" data-id="element-57" data-mp="2nizt0id5enc2" />
              Verify recruiter outreach
            </Link>
            <p className="text-xs text-gray-500 leading-relaxed max-w-sm" data-id="element-58" data-mp="1us8322moeux6">
              For verified company communications, use the official phone number and email listed below.
            </p>
          </div>

          {/* Practices */}
          <div className="lg:col-span-2" data-id="element-59" data-mp="23tz8r7h7v1r1">
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold-500 font-semibold mb-6" data-id="element-60" data-mp="23ql2vp9cgaeu">
              Practices
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-61" data-mp="3f7bejnwjdufu">
              <li data-id="element-62" data-mp="3fa5xtc3td97o">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-63" data-mp="3dqxlcs0kuha9">
                  Executive Search
                </Link>
              </li>
              <li data-id="element-64" data-mp="3npdd8x7fhukt">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-65" data-mp="3npv6dkysnsoi">
                  Board Recruitment
                </Link>
              </li>
              <li data-id="element-66" data-mp="iazpo6v7vgl">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-67" data-mp="3rqouofg5f9hx">
                  Leadership Advisory
                </Link>
              </li>
              <li data-id="element-68" data-mp="5audal5jyqle">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-69" data-mp="5cf6a6c7y1h5">
                  CEO Succession
                </Link>
              </li>
              <li data-id="element-70" data-mp="f775felg8we1">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-71" data-mp="xxkl2niefdha">
                  Talent Acquisition Consulting
                </Link>
              </li>
            </ul>
          </div>

          {/* Firm */}
          <div className="lg:col-span-2" data-id="element-72" data-mp="tvz1kjbd00y4">
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold-500 font-semibold mb-6" data-id="element-73" data-mp="tuxrah263ihg">
              The Firm
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-74" data-mp="f4zy1mpds2le">
              <li data-id="element-75" data-mp="jy2sdx1zfg2n">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors" data-id="element-76" data-mp="jykwffuvyyl4">
                  About
                </Link>
              </li>
              <li data-id="element-77" data-mp="a8jbuy1qryay">
                <Link to="/about#team" className="text-gray-300 hover:text-white transition-colors" data-id="element-78" data-mp="a5nat0ulktia">
                  Leadership Team
                </Link>
              </li>
              <li data-id="element-79" data-mp="22x0pwkzhaju3">
                <Link to="/how-it-works" className="text-gray-300 hover:text-white transition-colors" data-id="element-80" data-mp="22xiuq607i6dm">
                  Our Process
                </Link>
              </li>
              <li data-id="element-81" data-mp="1u4p3da7hjgje">
                <Link to="/testimonials" className="text-gray-300 hover:text-white transition-colors" data-id="element-82" data-mp="1u1t2bd0ccbqq">
                  Client Stories
                </Link>
              </li>
              <li data-id="element-83" data-mp="2ht89bj32bh8b">
                <Link to="/blog" className="text-gray-300 hover:text-white transition-colors" data-id="element-84" data-mp="2hut336hjyw54">
                  Insights
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4" data-id="element-85" data-mp="11f8egmj2qhrx">
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold-500 font-semibold mb-6" data-id="element-86" data-mp="11h2xtwep61tw">
              Contact
            </h4>
            <ul className="space-y-5" data-id="element-87" data-mp="wirkvct3vb7g">
              <li className="flex items-start gap-3" data-id="element-88" data-mp="mdjcxil8mei4">
                <MapPin className="h-5 w-5 text-gold-500 mt-0.5 flex-shrink-0" data-id="element-89" data-mp="manfdvdaxru7" />
                <div className="text-sm" data-id="element-90" data-mp="rbupw26tx54k">
                  <div className="text-white font-semibold mb-1" data-id="element-91" data-mp="wa4ji8cwnxo2">
                    Global Headquarters
                  </div>
                  <div className="text-gray-400 leading-relaxed" data-id="element-92" data-mp="11264cio52wpp">
                    357 7th Ave, 2nd Floor
                    <br data-id="element-93" data-mp="152g6fk8t92za" />
                    New York, NY 10001, United States
                  </div>
                </div>
              </li>
              <li className="flex items-center gap-3" data-id="element-94" data-mp="1f15pvhgcuvhn">
                <Phone className="h-5 w-5 text-gold-500 flex-shrink-0" data-id="element-95" data-mp="1f1oww34gvzgw" />
                <a href="tel:+16788073391" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-96" data-mp="1k0iadvjr7qh2">
                  +1 (678) 807-3391
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-97" data-mp="3lrve4h9zjsbj">
                <Mail className="h-5 w-5 text-gold-500 flex-shrink-0" data-id="element-98" data-mp="1rizpqieb9zhy" />
                <a href="mailto:contact@talentbridge.blog" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-99" data-mp="1mkok6jv1ub5j">
                  contact@talentbridge.blog
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Office strip */}
        <div className="py-8 border-t border-white/10" data-id="element-100" data-mp="18lymp34bi9gn">
          <div className="grid grid-cols-2 md:grid-cols-6 gap-6 text-xs" data-id="element-101" data-mp="13lspl7fa3ur6">
            {[{
            city: 'New York',
            label: 'Global HQ'
          }, {
            city: 'London',
            label: 'Europe'
          }, {
            city: 'Singapore',
            label: 'Asia Pacific'
          }, {
            city: 'Dubai',
            label: 'Middle East'
          }, {
            city: 'São Paulo',
            label: 'Latin America'
          }, {
            city: 'Johannesburg',
            label: 'Africa'
          }].map((office, i) => <div key={i} data-id="element-102" data-mp="2mls6cn3y2rbf" data-mpi={i}>
                <div className="text-white font-semibold" data-id="element-103" data-mp="2mml97czs8woa">{office.city}</div>
                <div className="text-gray-500 uppercase tracking-widest text-[10px] mt-1" data-id="element-104" data-mp="2rk3gz022d5up">
                  {office.label}
                </div>
              </div>)}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-gray-500" data-id="element-105" data-mp="35jcm94oqefjw">
          <p data-id="element-106" data-mp="3ah4n4o7ctc08">
            &copy; {new Date().getFullYear()} TalentBridge Global. All rights
            reserved. An AESC member firm.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-107" data-mp="6tchbqujlj73">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-108" data-mp="6uxabc17ku2u">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-109" data-mp="sfn8a7h5aub1">
              Terms of Service
            </Link>
            <Link to="/modern-slavery-statement" className="hover:text-white transition-colors" data-id="element-110" data-mp="ijtmdxhjdogl">
              Modern Slavery Statement
            </Link>
            <Link to="/recruitment-safety" className="text-gold-500 hover:text-white transition-colors" data-id="element-111" data-mp="8syy6nkqcesi">
              Recruitment Safety
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}